
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.667 3.867a5.66 5.66 0 01-1.573.426c.572-.341 1-.879 1.206-1.513a5.474 5.474 0 01-1.74.667A2.733 2.733 0 007.893 5.94 7.76 7.76 0 012.26 3.08a2.773 2.773 0 00-.045 2.67c.211.396.518.734.892.983a2.7 2.7 0 01-1.24-.34v.034a2.733 2.733 0 002.2 2.666 2.62 2.62 0 01-.734.114 3.267 3.267 0 01-.513-.047 2.74 2.74 0 002.554 1.893 5.48 5.48 0 01-4.04 1.134 7.713 7.713 0 004.193 1.233 7.726 7.726 0 007.807-7.787V5.28a5.62 5.62 0 001.333-1.413z","fill":"currentColor"}})])
          )
        }
      }
    